import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { IntroDescriptionPage } from './intro-description';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    IntroDescriptionPage,
  ],
  imports: [
    IonicPageModule.forChild(IntroDescriptionPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class IntroDescriptionPageModule {}



// WEBPACK FOOTER //
// ./src/pages/intro-description/intro-description.module.ts